import * as Cmp from "@impero-com/common/utils/comparison";
import * as DV from "@impero-com/common/utils/dataView";
import { ExportableArray } from "@impero-com/common/utils/export";

import { TagCategory } from "components/tag/types";

import { GroupView } from "./groupList";

interface UserGroupExportableEntry {
    id: number;
    groupName: string;
    createdBy: string;
    userId: number | undefined;
    userName: string | undefined;
    email: string | undefined;
    userTagsMap: Map<string, Array<string>>;
}

function exportUserGroups(
    dataView: DV.DataView<GroupView>,
    selectedIds: Array<string>
): ExportableArray {
    const tagCategoriesMap: Map<string, TagCategory> = new Map();
    const exportableEntries: Array<UserGroupExportableEntry> = [];

    DV.forEach(dataView.dataSource.iter(), (userGroup) => {
        if (selectedIds.findIndex((id) => id === userGroup.id.toString()) < 0) {
            return;
        }

        const { id, name: groupName, createdBy } = userGroup;

        if (userGroup.users.length === 0) {
            exportableEntries.push({
                id,
                groupName,
                createdBy,
                userId: undefined,
                userName: undefined,
                email: undefined,
                userTagsMap: new Map(),
            });
            return;
        }

        userGroup.users.forEach((userInGroup) => {
            const { id: userId, email, name: userName } = userInGroup;

            const userTagsMap: Map<string, Array<string>> = new Map();

            userInGroup.tags.forEach((tag) => {
                const tagCategory = userInGroup.tagCategories.find(
                    (cat) => tag.tagCategoryId === cat.id
                )!;

                const categoryEntry = userTagsMap.get(tagCategory.id) || [];
                categoryEntry.push(tag.name);
                userTagsMap.set(tagCategory.id, categoryEntry);

                tagCategoriesMap.set(tagCategory.id, tagCategory);
            });

            exportableEntries.push({
                id,
                groupName,
                createdBy,
                userId,
                userName,
                email,
                userTagsMap,
            });
        });
    });

    const tagCategoriesArray: Array<TagCategory> = [];
    tagCategoriesMap.forEach((tc, _tcId) => {
        tagCategoriesArray.push(tc);
    });
    tagCategoriesArray.sort(Cmp.map((tc) => tc.name, Cmp.string()));

    return {
        content: exportableEntries.map((entry) => [
            entry.id,
            entry.groupName,
            entry.createdBy,
            entry.userId,
            entry.userName,
            entry.email,
            ...tagCategoriesArray.map((tc) => {
                const tags = entry.userTagsMap.get(tc.id) || [];
                return tags.join(", ");
            }),
        ]),
        header: [
            "Id",
            "Group name",
            "Created by",
            "User id",
            "User name",
            "Email",
            ...tagCategoriesArray.map((tc) => "UserTags: " + tc.name),
        ],
    };
}

export { exportUserGroups };
